export type PaymentType = 'contract' | 'order';
export type PlanType = 'standard' | 'pro';

export type ChurnReasonCode = 'switched_tool' | 'missing_features' | 'business_closure' | 'other';

export const CHURN_REASON_OPTIONS: { value: ChurnReasonCode; label: string }[] = [
  { value: 'switched_tool', label: '他社ツールへの乗り換え' },
  { value: 'missing_features', label: '期待した機能がなかった' },
  { value: 'business_closure', label: '事業縮小・閉鎖' },
  { value: 'other', label: 'その他（自由記述）' }
];

export interface DowngradeSchedule {
  effective_at: string;
  to_plan_name: string;
  scheduled_by_name: string | null;
  scheduled_at: string;
}
